export const API_URL = "https://ncdc-api-rf5pq.ondigitalocean.app/api";
export const UPLOADS_URL = "https://spaces.ncdcplayground.com";
export const APP_URL = "http://vle.ncdc.go.ug";
